export default __webpack_public_path__ + "static/media/qr.990c19c8.jpg";